import {
  useQuery,
} from '@tanstack/react-query'

import { singularResourcefulJointScenarioRequest } from '../requests'

export function useAssetAllocationQuery({
  jointScenarioId,
  initialData,
  queryKey
}) {

  const assetAllocationRequests = singularResourcefulJointScenarioRequest(
    jointScenarioId, 'asset_allocation'
  )

  const assetAllocationQuery = useQuery({
    queryFn: assetAllocationRequests.show,
    queryKey,
    initialData
  })

  const isFetching = assetAllocationQuery.isFetching

  return {
    data: assetAllocationQuery.data,
    status: assetAllocationQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching
  }
}
